import React from "react";
import HAvatar from "./HAvatar";
import { Constants } from "../utils/constants";

const HAvatarGroup = ({ avatars }) => {
  return (
    <div className="flex -space-x-2">
      {avatars.map((avatar, index) => (
        <HAvatar
          key={index}
          src={avatar.src}
          alt={avatar.alt}
          className="h-8 w-8"
          style={{
            border: `2px solid ${Constants.HOST_EXPERIENCE_BASE_COLOR}`,
          }}
        />
      ))}
    </div>
  );
};

export default HAvatarGroup;
